// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"183":"607d4770","348":"3cc4f7b0","453":"406c13f6","474":"60ede78c"}[chunkId] + ".chunk.js";
};